import {NgModule} from '@angular/core';
import {MathService} from './math.service';

@NgModule({
  declarations: [],
  exports: [],
  providers: [MathService]
})
export class MathModule {
}
